@if (canViewPaymentsTable) {
    <p class="mat-body-2">Payments (GST Inclusive)</p>
    <cb-table class="cb-margin-top" label="Payments" [loaded]="true" [minWidth]="750">
        <thead cbTableHead>
            <tr cbTableRow>
                <td>Event/Stage</td>
                <td>Type</td>
                <td>%</td>
                <td>Payment Amount</td>
            </tr>
        </thead>
        <tbody cbTableBody>
            @for (
                progressPayment of contractPricingUpdateDto.lotProgressPayments
                    | cbSortByPipe: 'sortOrder' : 'asc';
                track progressPayment;
                let index = $index
            ) {
                <tr cbTableRow>
                    @if (progressPayment.buildStageId) {
                        <cb-td-text [value]="progressPayment.buildStageLabel"></cb-td-text>
                    }
                    @if (!progressPayment.buildStageId) {
                        <cb-td-text [value]="progressPayment.paymentTemplateEvent.label">
                        </cb-td-text>
                    }
                    <cb-td-enum
                        [value]="progressPayment.amountType"
                        [enum]="PAYMENT_TEMPLATE_AMOUNT_TYPE_ENUM"
                    >
                    </cb-td-enum>
                    <td>
                        <cb-input
                            type="number"
                            (ngModelChange)="progressPayment.percentage = $event"
                            [ngModelOptions]="{ updateOn: 'blur' }"
                            [ngModel]="+(progressPayment.percentage || 0 | number: '1.2-2')"
                            [readonly]="percentageReadOnly(progressPayment)"
                            [name]="progressPayment.buildStage?.label + '_percentage_' + index"
                            (change)="setDollarValueFromPercentage(progressPayment)"
                        >
                        </cb-input>
                    </td>
                    <td>
                        <cb-currency
                            [name]="progressPayment.buildStage?.label + '_dollar_value_' + index"
                            [ngModel]="progressPayment.dollarValue | number: '1.2-2'"
                            (ngModelChange)="progressPayment.dollarValue = $event"
                            [readonly]="dollarValueReadOnly"
                            (change)="setPercentageFromDollarValue(progressPayment)"
                        >
                        </cb-currency>
                    </td>
                </tr>
            }
            <tr cbTableRow class="table-pink">
                <cb-td-text value="Balance"></cb-td-text>
                <td></td>
                <td>
                    <cb-display-value-new class="cb-margin-bottom-nil">
                        {{ percentTotal | number: '1.2-2' }}
                    </cb-display-value-new>
                </td>
                <td>
                    <cb-display-value-new class="cb-margin-bottom-nil">
                        {{ balance | cbCurrency }}
                    </cb-display-value-new>
                </td>
            </tr>
        </tbody>
    </cb-table>
}
